import React, { Component } from 'react';

import OrdasofnList from './OrdasofnList';

class Frontpage extends Component {
	render() {
		return (
			<div className="row">
				<div className="col-md-8 offset-md-2">

					<div className="card info-red-card sticky">
						<div className="card-body">
							<h2 className="card-title">Íðorðabankinn</h2>
							<p>Íðorðabankinn er uppflettisafn orða á íslensku og fleiri tungumálum innan ákveðinna starfs- eða fræðigreina.</p>
						</div>
					</div>

					<div className="card">
						<div className="card-body">
							<p>Leit í orðabankanum er óháð markmáli, leitarniðurstöður birtast um leið og tveir eða fleiri bókstafir hafa verið slegnir inn í leitarreitinn. Í leitarniðurstöðunum gefst kostur á að flokka eftir þeim orðasöfnum sem niðurstöður fundust í. Einnig er boðið upp á röðun eftir þeim tungumálum sem tiltæk eru.</p>
							<p>Eitt af hlutverkum orðabanka er að samræma orðanotkun innan skyldra og óskyldra greina.
							Hann á að safna fræðiheitum og sameina þau þannig að ekki séu á kreiki mörg heiti um sama fyrirbærið.
							Íðorðbanki Stofnunar Árna Magnússonar í íslenskum fræðum sinnir þessu hlutverki.
							Hann getur veitt yfirsýn yfir íslenskan íðorðaforða og nýyrði úr almennu máli, sem eru efst á baugi, og stuðlað með því að auknu samræmi bæði í orðanotkun og skilgreiningum. Auk þess veitir hann aðgang að íslenskum þýðingum á erlendum íðorðum, og jafnframt því aðgang að hugtakaskilgreiningum íðorða á íslensku og fleiri tungumálum.</p>
							<p>Íðorðabankinn getur því gagnast vel öllum þeim sem fjalla um sérfræðileg efni, þýðendum, kennurum, nemendum, fjölmiðlafólki, opinberum stofnunum, fyrirtækjum svo og hvers kyns áhugafólki, og síðast en ekki síst orðabókarhöfundum þar sem hann er sérstaklega ætlaður til orðabókasmíða.</p>
						</div>
					</div>

				</div>
			</div>
		);
	}
}

export default Frontpage;



// WEBPACK FOOTER //
// ./src/components/Frontpage.js